import { useQuery } from "react-query";

import { getFullName } from "helpers";
import { dropdownValuesService } from "services";

type UsePrimaryAgentsQueryProps = {
	applicationId?: string;
	onSuccess?: any;
};

const usePrimaryAgentsQuery = ({
	applicationId,
	onSuccess,
}: UsePrimaryAgentsQueryProps = {}) => {
	return useQuery(
		"primaryAgents",
		() => dropdownValuesService.getPrimaryAgents(applicationId),
		{
			onSuccess,
			select: response => {
				return response.map(data => ({
					value: `${data.id}`,
					name: getFullName(data),
					partnerType: data.partnerType,
					companyId: data.company.id,
				}));
			},
		},
	);
};

export default usePrimaryAgentsQuery;
